import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformResponse
} from './transform';

import {
    addActionNextgen as addPatientGlobalSearchNextgen,
    setSpin,
} from 'one-state-patient-global-search';
import { format } from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";

export const enum Types {
    SEARCH_NEXTGEN = 'one-state-patient-global-search/search-nextgen',
    ADD_NEXTGEN = 'one-state-patient-global-search/add-nextgen',
    PushDatatoSubject = 'one-state-subject/set',
}


const pushToSetPatientGlobalSearch = (payload: any) => addPatientGlobalSearchNextgen(payload);

/**
 * This Function fetches data from getgetpatientepicglobal api
 * @param context contains settings.json etc...
 */
export const fetchPatientsGlobalSearchNextgen = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings:
            {
                servers, compatible, nextgenendpoints: { getpatientnextgen }
            }
        } = context;
        const { finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.SEARCH_NEXTGEN),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */

                const dataresponse: any = action.payload;
                log.debug("one-nextgen", "patient-global-search request", dataresponse);
                const getCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.append("Accept", "application/json");
                    headers.append("Content-Type", "text/plain");
                    let getParams = "";
                    var parts = payload.birthdate.split('-');

                    if (payload.phone) {
                        getParams += "&quickSearchId=PhoneNumber" ;
                        getParams += "&quickSearchInput=" + payload.phone;
                    }
                    else if (payload.birthdate && payload.name) {
                        // getParams += "&quickSearchId=DateOfBirth" ;
                        getParams += "&DateOfBirth=" + parts[2] + '-' + parts[0] + '-' + parts[1];
                        getParams += "&Name=" + payload.name
                    }
                    else if (payload.name ) {
                        // getParams += "&quickSearchId=Name" ;
                        getParams += "&Name=" + payload.name;
                    }
                    else if (payload.birthdate) {
                        // getParams += "&quickSearchId=DateOfBirth" ;
                        getParams += "&DateOfBirth=" + parts[2] + '-' + parts[0] + '-' + parts[1];
                    }
                   
                    else if (payload.id) {
                        getParams += "&quickSearchId=MedicalRecordNumber" ;
                        getParams += "&quickSearchInput=" + payload.id;
                    }
                    
                    // Remove the leading "&" if there are any parameters
                     if (getParams.length > 0) {
                        getParams = "?" + getParams.substring(1);
                    }
                    let response;
                    if (finesse_proxy_service) {
                        //response = InvokeFinesseProxy(getpatientepic, data, locations, log, 'POST', alertnotification);

                    } else {
                        response = server.get({
                            path: getpatientnextgen + getParams,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error("one-epic", "patient-global-search-nextgen Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Patient Global Search",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                            })
                        log.debug("one-epics", "patient-global-search-nextgen response", response);
                    }
                    return from(response);
                }
                return getCallerDetails(dataresponse).pipe(
                    map(response => TransformResponse(response, context))
                ).pipe(
                    flatMap(response => {
                        const payloadPhone = dataresponse.phone ? dataresponse.phone.replace(/\D/g, '') : null;
                        let payloadparam = ""
                        if (dataresponse?.id) {
                            payloadparam = dataresponse.id
                        }
                        else if (dataresponse?.name) {
                            payloadparam = dataresponse.name
                        }
                        else if (dataresponse?.birthdat) {
                            payloadparam = dataresponse.birthdate
                        }
                        else if (dataresponse?.phone) {
                            payloadparam = dataresponse.phone
                        }
                        const responseData = response.subjectdata.map((subject: any) => {
                            if (payloadPhone) {
                                console.log("formatPhoneNumber",subject.phoneNumbers)
                                subject.phoneNumbers = subject.phoneNumbers.filter((item: any) => item.Number.replace(/\D/g, '') === payloadPhone)
                            }
                            subject.phone = subject.phoneNumbers?.length > 0 ? subject.phoneNumbers[0] : {}
                            return subject
                        })
                        const actions: any = [
                            pushToSetPatientGlobalSearch(responseData)
                        ];
                        // check for error messages.
                        if (response.error) {
                            actions.push(addAction(response.error));
                            //To store the error object in the reducer.
                            actions.push(lookupErrorSet(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will stop spinner for 
 * patient global search epic redux action
 * @param context contains the settings,logger etc..
 */
export const resetSpinForPateintGlobalSearchNextgen = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,patient-global-search-nextgen",
            "setSpin-patient-global-search-nextgen", {
        });
        return action$.pipe(
            ofType(Types.ADD_NEXTGEN),
            map(action => setSpin(false))
        )
    }
);
